import React, { Component } from 'react'
import { connect } from 'react-redux';
import Header from "../../Header/Header";
import { withTranslation } from 'react-i18next';
import { loginActions } from '../../action/loginAction';
import { alertActions } from '../../action/AlertAction';
import HomeSlidTabs from '../Home/HomeSlidTabs';
import RenderCasino from '../Home/RenderCasino';
import { history } from '../../helpers/history';
class Instant extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPopUp: false,
            slotname: "",
            locadet: window.location.pathname.split('/')[window.location.pathname.split('/').length - 1].toLowerCase()
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    };

    handleChange = (e) => {
        try {
            this.setState({ [e.target.name]: e.target.value });
        }
        catch (ex) { }
    }

    render() {
        const { t } = this.props;
        return (
            <div className="mainContainer bg5">
                <Header />
                <div class="container">
                    <HomeSlidTabs />
                    <div class="rht bg2 content">
                        <div class="bredCrums">
                            <ul>
                                <li><a onClick={() => { history.push('/') }}> {t('lblHome')}<img src="./assets/img/icons/right-angle.png" /></a></li>
                                {
                                    this.state.locadet == 'instant' ? <li><a class="active">{t('lblonlslot')}</a></li> :
                                        <li><a class="active">Roulette</a></li>
                                }
                            </ul>
                        </div>
                        <div class="myAccount">
                            {this.state.locadet == 'instant' ?
                                <h2 class="headding1">{t('lblonlslot')}</h2> :
                                <h2 class="headding1">Roulette </h2>
                            }
                            <div class="filters3">
                                <div class="filtersCont3">
                                    <span>
                                        <label>Search by Name</label>
                                        <input type="text" className="custDate" id="txtAmount" placeholder="Enter game name" name="slotname" value={this.state.slotname} onChange={(e) => this.handleChange(e)} />
                                    </span>
                                </div>
                            </div>
                            <div class="slotGmaes scratchCrds">
                                {this.state.locadet == 'instant' ? <ul>
                                    <RenderCasino renderkey={3} slotnamefilter={this.state.slotname} />
                                </ul>
                                    :
                                    <RenderCasino renderkey={8} slotnamefilter={this.state.slotname} />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div >

        )
    };
}

function mapStateToProps(state) {
    console.log(state)
    const { appvariables, user } = state.loginReducer;
    return { appvariables, user }
}

const mapActionToProps = {
}

export default connect(mapStateToProps, mapActionToProps)(withTranslation()(Instant))